import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';
import { Section, Block } from 'core/components/Grid';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';

function ColumnLayout(props) {
  const {
    children,
    rightColumn,
    theme,
    isMobile,
  } = props;

  if (isMobile) return children;

  const {
    contentColumnMaxWidth,
    sideColumnIndent: themeSideColumnIndent,
    rightColumnWidth,
  } = theme.layout;

  const sideColumnIndent = props.sideColumnIndent || themeSideColumnIndent;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .sideColumn
          margin-left ${sideColumnIndent}
      `}</style>
    </scope>
  );

  return (
    <Section>
      <Block maxWidth={contentColumnMaxWidth}>
        {children}
      </Block>
      <Block
        width={rightColumnWidth}
        mobile={0}
        className={scoped.wrapClassNames('sideColumn')}
      >
        <div className={styles.column}>
          {rightColumn}
        </div>
      </Block>
      <scoped.styles />
    </Section>
  );
}

ColumnLayout.propTypes = {
  /** @ignore */
  isMobile: PropTypes.bool,
  /** @ignore */
  theme: themePropTypes(`
    {
      layout: {
        contentColumnMaxWidth,
        sideColumnIndent,
        rightColumnWidth,
      },
    }
  `),
  /**
   * Контент, который будет отрендерен в сайдбаре.
   */
  rightColumn: PropTypes.node,

  /**
   * Отступ правой колонки от левой.
   * Переопределяет значение из темы.
   */
  sideColumnIndent: PropTypes.string,
};

const ColumnLayoutWithHOCs = withBreakpoint(withTheme(ColumnLayout));
ColumnLayoutWithHOCs.displayName = 'ColumnLayout';

export { ColumnLayout as StorybookComponent };
export default ColumnLayoutWithHOCs;
